import { levels, colors, logLevel, stderrLevels } from './logger-common';

const logLevelInt = levels[logLevel];
const browserColors = { ...colors, FATAL: 'red; font-weight: bold' };
const devLog = process.env.NODE_ENV !== 'production';

export const log = (level, msg, data) => {
	/* eslint-disable no-console */
	if (devLog && levels[level] <= logLevelInt) {
		const color = `color: ${browserColors[level]}`;
		const outputStream = stderrLevels.has(level)
			? console.error
			: console.log;
		outputStream(`%c${level} : ${msg}`, color);
		if (data) {
			outputStream(`%c${JSON.stringify(data, undefined, 4)}`, color);
		}
	}
	/* eslint-enable no-console */
};



// WEBPACK FOOTER //
// ./~/ws-scripts/src/modules/logger/logger-browser.js